import React from 'react';

type BadgeVariant = 'green' | 'amber' | 'red' | 'neutral' | 'blue';

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
  icon?: React.ReactNode;
}

const variantClasses: Record<BadgeVariant, string> = {
  green:   'bg-v2-green-100 text-v2-green-700',
  amber:   'bg-[#FFF3DC] text-[#8A5A00]',
  red:     'bg-[#FDEAEA] text-v2-red-500',
  neutral: 'bg-v2-neutral-100 text-v2-neutral-600',
  blue:    'bg-blue-50 text-blue-700',
};

export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'neutral',
  className = '',
  icon,
}) => (
  <span
    className={`
      inline-flex items-center gap-1.5 text-[12px] font-semibold px-2.5 py-1 rounded-v2-full
      ${variantClasses[variant]} ${className}
    `}
  >
    {icon && <span className="shrink-0">{icon}</span>}
    {children}
  </span>
);
